<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-chart-bubble`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.1768 10.2617C13.3269 10.2617 14.2596 11.1937 14.2598 12.3438C14.2598 13.494 13.3269 14.4268 12.1768 14.4268C11.0267 14.4266 10.0947 13.4937 10.0947 12.3438C10.0949 11.1939 11.0268 10.262 12.1768 10.2617ZM4.5459 8.48438C6.09579 8.48464 7.35228 9.74112 7.35254 11.291C7.35254 12.8411 6.09595 14.0984 4.5459 14.0986C2.99563 14.0986 1.73828 12.8413 1.73828 11.291C1.73854 9.74096 2.99578 8.48438 4.5459 8.48438ZM10.3789 1.57422C12.153 1.57433 13.5907 3.0122 13.5908 4.78613C13.5908 6.56017 12.1531 7.99891 10.3789 7.99902C8.60489 7.99902 7.16699 6.56015 7.16699 4.78613C7.16712 3.01222 8.60513 1.57422 10.3789 1.57422Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineChartBubble',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
